import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import { CodeSurfer, CodeSurferColumns, Step } from "code-surfer";
import { github, nightOwl, vsDark } from "@code-surfer/themes";
const styledCenter = {
  width: "fit-content",
  textAlign: "center",
  borderBottom: '10px solid',
  borderImageSource: "linear-gradient(120deg, #1890ff, #db18ff)",
  borderImageSlice: 5
};
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <CodeSurfer mdxType="CodeSurfer">
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "title=\"useTimeline\" subtitle=\"maintain values throughout renders\"",
          "title": "\"useTimeline\"",
          "subtitle": "\"maintain",
          "values": true,
          "throughout": true,
          "renders\"": true
        }}>{`export default function useTimeline(value, maxLength) {
  const valuesRef = useRef([]);
  const prevValue = usePrevious(value);

  if (!Object.is(value, prevValue)) {
    valuesRef.current = [...valuesRef.current, value];
  }

  if (valuesRef.current.length > maxLength) {
    valuesRef.current.splice(0, valuesRef.current.length - maxLength);
  }

  return valuesRef.current;
}

`}</code></pre>
      <pre><code parentName="pre" {...{
          "className": "language-jsx",
          "metastring": "title=\"inside component useTimeline\"",
          "title": "\"inside",
          "component": true,
          "useTimeline\"": true
        }}>{`function Component() {

  const [count, setCount] = useState(0);
  const counts = useTimeline(count);
  return \`Now: \${count}, history: \${counts}\`;

}
`}</code></pre>
    </CodeSurfer>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      